import React, { Fragment, useState } from 'react';
import { useTranslate } from 'react-admin';

import PIAvailabilityForm from './PIAvailabilityForm';
import { Drawer, CreateButton } from '~/components';
import { CreateForm } from '~/components/ra';
import { Solution } from '~/types';
import { productLabel as l } from '.';
import { PIAvailability } from '~/types/solutions';

interface Props {
  record: PIAvailability | null;
  solutionRecord: Solution;
  permissions: string[];
}
const PIAvailabilityCreate = (props: Props) => {
  const { record, solutionRecord, permissions } = props;

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const translate = useTranslate();
  const t = (key: string): string => translate(l(key));

  return (
    <Fragment>
      <CreateButton
        onClick={handleOpen}
        variant='add'
        disabled={!permissions.includes('solution.paymentInstrumentAvailabilityRules.create')}
      />
      <Drawer heading={t('addPaymentInstrument')} open={open} onClose={handleClose}>
        <CreateForm
          resource='paymentInstrumentAvailabilityRules'
          target='solutions'
          id={solutionRecord.id}
          record={{ solutionId: solutionRecord?.id }}
          closeParent={handleClose}
        >
          <PIAvailabilityForm record={record} solutionRecord={solutionRecord} create />
        </CreateForm>
      </Drawer>
    </Fragment>
  );
};

export default PIAvailabilityCreate;
